<template>
    <div id="wrapper" >
      <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.terms.label.title')}}</h4>

                            </div>
                        </div>
                    </div>

                     <div class="row">
                       
                       <div class="col-lg-12">
                        <div class="card-box">
                            <h4 class="header-title mb-4">
                                <h4 class="page-title">
                                    {{$t('string.msg.terms.system.label.title')}}
                                </h4>
                            </h4>
                     
                                <b-tabs>

                                    <b-tab active >
                                        <template v-slot:title>
                                            <strong>{{$t('string.msg.term.geral.label.title')}}</strong>
                                        </template>
                                        <ModalTerm />
                                    </b-tab>


                                    <div v-if="hasType('PART_SUPPLIER')">
                                        <b-tab :class="{ 'hidden': !hasType('PART_SUPPLIER') }">
                                            <template v-slot:title>
                                                <strong>{{$t('string.msg.term.accession.part.label.title')}}</strong>
                                            </template>
                                            <ModalTermParts v-if="hasType('PART_SUPPLIER')" :dataCompany="dataCompany"  />
                                        </b-tab>
                                    </div>


                                    <div v-if="hasType('SERVICE_PROVIDER')">
                                        <b-tab v-bind:class="{ 'hidden': !hasType('SERVICE_PROVIDER') }">
                                            <template v-slot:title>
                                                <strong>{{$t('string.msg.term.accession.service.provider.label.title')}}</strong>
                                            </template>
                                            <ModalTermServices  v-if="hasType('SERVICE_PROVIDER')" :dataCompany="dataCompany"  />
                                        </b-tab>
                                    </div>
                                    
                                    <div v-if="hasType('CERTIFIER')">
                                        <b-tab v-bind:class="{ 'hidden': !hasType('CERTIFIER') }">
                                            <template v-slot:title>
                                                <strong>{{$t('string.msg.term.accession.certifier.label.title')}}</strong>
                                            </template>
                                            <ModalTermCertifies   v-if="hasType('CERTIFIER')" :dataCompany="dataCompany"  />
                                        </b-tab>
                                    </div>

                                </b-tabs>
                            
                        </div>
                        <!-- end card-box-->
                      </div>
                      <!-- end col -->
                     </div>
          
                </div>
              
            </div>
        </div>
        
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
      
    </div>
</template>

<script>

import Controller from './CrtTerms';
import Spinner from '../../components/layout/Spinner';
import Toast from '../../components/layout/Toast';

import ModalTerm from './Modal/ModalTerm';
import ModalTermParts from './Modal/ModalTermParts';
import ModalTermServices from './Modal/ModalTermService';
import ModalTermCertifies from './Modal/ModalTermCertifie';


import BootstrapVue from 'bootstrap-vue'
import Vue from 'vue'
Vue.use(BootstrapVue)

export default {
    name: 'Dashboard',
    components: {
    Spinner,
    Toast,
    ModalTerm,
    ModalTermParts,
    ModalTermServices,
    ModalTermCertifies
    },
    data() {
        return {
            errors: [],
            titleToast: null,
            messageToast: null,
            messageIdToast: null,
            orders: [],
            checkTerm: null,
            dataCompany:{},
            data: {
            },
            user: {
                serviceTypes: []
            }
        }
    },
    methods: Controller.methods,
    created() {
    },
    mounted() {
        Controller.init(this);
    }
    }
    </script>

    <style>
    </style>
